import React from "react";
import PropTypes from "prop-types";
import FormRowField from "shared/react_components/FormRowField";
import { CheckboxWithLabel } from "shared/formik/formik_helpers";

const UserLicenseCheckbox = ({ name, label, onLicensesChange }) => (
  <FormRowField name={name}>
    {({ field, form }) => (
      <CheckboxWithLabel field={field} form={form} label={label} onChange={onLicensesChange}/>
    )}
  </FormRowField>
);

UserLicenseCheckbox.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onLicensesChange: PropTypes.func.isRequired
};

export default UserLicenseCheckbox;
